import React from 'react';

import { EmailInput } from '@app/common/configurable-wizards/fields/email/EmailInput';
import { EmailFieldFragment } from '@app/common/configurable-wizards/queries/queryTyping/all-fields';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { isEmailField, combineNames } from '@app/common/configurable-wizards/utils';

/**
 * EmailInput wrapped as Field
 */
export const EmailFieldDetails: FieldComponent<EmailFieldFragment> = ({
  parent,
  field,
  fieldProps,
}) => {
  const emailFieldName = combineNames(parent, field.id);

  return (
    <>
      <EmailInput
        name={emailFieldName}
        field={field}
        {...fieldProps}
      />
    </>
  );
};

export const DetailEmailFieldLocator: FieldLocator = ({ field }) => (
  isEmailField(field)
    ? EmailFieldDetails
    : undefined
);
